import { PureComponent } from 'react';
import Reload from './reload';
import RedirectComponent from './redirect';
import { redirectionSteps } from '../../constants/steps';
import i10n from '../../common/i10n';
import warning from '../../assets/images/warning-avepdf-svg-black.svg';
import error from '../../assets/images/avepdf-svg-black-error-file.svg';
class Error extends PureComponent {

    render() {
        //imported via uri
        const iconRef = this.props.isWarning ? warning : error;

        return (
            <div className="w-100">
                <div className="d-flex align-items-center align-content-stretch justify-content-center row response-error-wrapper">
                    <div>
                        <img width="" height="" alt="" src={iconRef} />
                    </div>
                    <div className="upload-container text-center">
                        <div className="tool-action-title">{this.props.title || (this.props.isWarning ? i10n._VIEW_TOOL_LAYOUT_OPERATION_ABORTED : i10n._VIEW_TOOL_LAYOUT_ERROR_WITH_FILE)}</div>
                        <div className="tool-action-sub-title">{this.props.subtitle}</div>
                        {
                            !window.embedded && this.props.redirectionStep==redirectionSteps.beforeRedirection &&
                            <RedirectComponent
                                backButtonColor={this.props.backButtonColor}
                            />
                        }
                        <Reload
                            buttonView={true}
                            buttonColor={this.props.backButtonColor}
                            onReload={this.props.onReload}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const ErrorContainer = Error;
export default ErrorContainer;